export const formControlStyle=
     {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "black",   
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "black",           
    },
  } 
